<!-- Drawer -->
<nz-drawer [nzBodyStyle]="{ overflow: 'auto' }" [nzMaskClosable]="false" [nzWidth]="1040"
  [nzVisible]="ViewManPowerVisible" [nzFooter]="footerTpl" (nzOnClose)="close()">

  <!-- Side swipe content -->
  <div class="row d-print-block">
    <div class="col-lg-12 grid-margin stretch-card">
      <div class="card">
        <h5 class="card-title">Man Power Request Details</h5>
        <div class="card-body">
          <h5>REQUESTOR DETAILS</h5>
          <div class="row">

            <div class="col">
              <label><b>Request Reference</b></label>
              <p>{{ ApproveRequest?.reference }}</p>
            </div>
            <div class="col">
              <label><b>Requester Name</b></label>
              <p>{{ ApproveRequest?.requesterName }}</p>
            </div>
          </div>
          <div class="row">
          
          <div class="col">
            <label><b>Requester Function</b></label>
            <p>{{ ApproveRequest?.requesterFunction }}</p>
          </div>
          <div class="col">
            <label><b>Requester Unit</b></label>
            <p>{{ ApproveRequest?.requesterUnit }}</p>
          </div>
          </div>
          <div class="row">
          
            <div class="col">
              <label><b>Requester Designation</b></label>
              <p>{{ ApproveRequest?.requesterDesignation }}</p>
            </div>
            <div class="col">
              <label><b>Request Date</b></label>
              <p>{{ ApproveRequest?.requestDate  | date: 'dd MMMM yyyy'}}</p>
            </div>

            </div>
       
          <hr>
          <h5>DETAILS OF REQUIRED MANPOWER</h5>
          <div class="row">
            <div class="col">
              <label><b>Job Title</b></label>
              <p>{{ ApproveRequest?.jobTitle }}</p>
            </div>

            <div class="col">
              <label><b>N + 1 Designation</b></label>
              <p>{{ ApproveRequest?.nPlus1Designation }}</p>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <label><b>Band</b></label>
              <p>{{ ApproveRequest?.band }}</p>
            </div>

            <div class="col">
              <label><b>Cost Center</b></label>
              <p>{{ ApproveRequest?.costCenter }}</p>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <label><b>Location</b></label>
              <p>{{ ApproveRequest?.location }}</p>
            </div>

            <div class="col">
              <label><b>Date Vacancy Occured</b></label>
              <p>{{ ApproveRequest?.dateVacancyOccurred | date: 'dd MMMM yyyy'}}</p>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <label><b>Required Number</b></label>
              <p>{{ ApproveRequest?.requiredNumber }}</p>
            </div>
            <div class="col">
              <label><b>Type Of Vacancy</b></label>
              <p>{{ ApproveRequest?.typeOfVacancy }}</p>
            </div>

  
          </div>

          <div class="row">
            <div class="col">
              <label><b>Reason For Vacancy</b></label>
              <p>{{ ApproveRequest?.reasonForVacancy }}</p>
            </div>

            

          </div>
            
        <div class="row">
          <div class="col">
            <label><b>Mode Of Recruitment</b></label>
            <p>{{ ApproveRequest?.modeOfRecruitment }}</p>
          </div>

          <div class="col">
            <label><b>Duration Of Contract</b></label>
            <p>{{ ApproveRequest?.durationOfContract }}</p>
          </div>

        </div>

        <div class="row">
          <div class="col">
            <label><b>Estimated Annual Cost</b></label>
            <p>{{ ApproveRequest?.estimatedAnnualCost }}</p>
          </div>

          <div class="col">
            <label><b>Justification For Vacancy</b></label>
            <p>{{ ApproveRequest?.justificationForVacancy }}</p>
          </div>

        </div>
        </div>
        

        <hr>

        <!-- Non Editable View -->
        <div class="card-body">
          <div class="row">

            <div class="col">
              <label><b>Request Date</b></label>
              <p>{{ ApproveRequest?.createdDate | date: 'dd MMMM yyyy' }}</p>
            </div>

            <div class="col">
              <label><b>Educational Qualification</b></label>
              <p>{{ ApproveRequest?.qualification }}</p>
            </div>
          </div>

          <div class="row">

            <div class="col">
              <label><b>Skills Required</b></label>
              <p>{{ ApproveRequest?.skillsRequired }}</p>
            </div>

            <div class="col">
              <label><b>Experience</b></label>
              <p>{{ ApproveRequest?.experience }}</p>
            </div>
          </div>

          <div class="row">

            <div class="col">
              <label><b>Syetem Requirements</b></label>
              <p>{{ ApproveRequest?.systemRequired }}</p>
            </div>

            <div class="col">
              <label><b>Requested By</b></label>
              <p>{{ ApproveRequest?.createdBy }}</p>
            </div>
            
          </div>

          <div class="row">

            <div class="col">
              <label><b>Other System Required</b></label>
              <p>{{ ApproveRequest?.otherSystemRequirements }}</p>
            </div>
          </div>
        
          <div class="row" *ngIf="ViewlevelOfCompliance">
            <div class="col">
              <label><b>Approved Budget For The Department</b></label>
              <p>{{ ApproveRequest?.presentDepartmentManpowerFigure }}</p>
            </div>
            <div class="col">
              
              <label><b>Present Manpower Figure For The Department</b></label>
              <p>{{ ApproveRequest?.presentDepartmentManpowerFigure }}</p>
            </div>
            <div class="col">
              <label><b>Level of Risk Risk Exposure(Compliance)</b></label>
              <br>
              <p [ngClass]="getColor(ApproveRequest?.levelOfExposureCompliance)">{{ ApproveRequest?.levelOfExposureCompliance }}</p>
            </div>
          </div>
         <br>
         <hr>
          <div class="row">
            <div class="col">
              <div class="col pull right" >	
                <button (click)="getJD(ApproveRequest)">Download Job Description</button>
              </div>
              
            </div>

            <div class="col">
              <div class="col pull right" >	
              <nz-space>
                 
                  <button *nzSpaceItem nz-button nzType="primary" (click)="showDocument(ApproveRequest)">View document</button>
                </nz-space>
          </div>
        </div>
            <div>
        
              <!-- <ngx-extended-pdf-viewer [base64Src]="receivedfile" [useBrowserLocale]="true"
              [handTool]="false" *ngIf="isFileDocument" height="9000vh" [showHandToolButton]="true" backgroundColor="#ffffff">
              </ngx-extended-pdf-viewer> -->
            </div>

          </div>
            <br>
            <hr>
        </div>
      </div>

    </div>
  </div>
   <!-- Approvals -->
   <div class="card-body" >
    <h5 class="card-title">Approvals</h5>
    <div class="table-responsive" >
      <table class="table table--striped table-hover">
        <thead>
          <tr>
            <th>
              Designation Name
            </th>
            <th>
              Approved By
            </th>
            <th>
              Date Approved
            </th>
            <th>
              Message
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let approval of ManPowerApprovals">
            <td>{{approval.designationName}}</td>
            <td>{{approval.approvedBy}}</td>
            <td>{{approval.dateOfApproval | date: 'dd MMMM yyyy hh:mm a'}}</td>
            <td>{{approval.message}}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div *ngIf="!ManPowerApprovals?.length"
      style="color: rgba(128, 128, 128, 0.741); text-align: center; padding: 18px;">
      <h4 style="color: rgba(128, 128, 128, 0.741);">No approval has been granted.</h4>
    </div>
    <!-- Approvals -->
  </div>
  <ng-template #footerTpl>
    <div style="float: right" class="d-print-none">
   
      <button class="btn btn-light" style="margin-right: 8px;" (click)="close()">Close</button>
    </div>
  </ng-template>

</nz-drawer>
<div class="content-wrapper d-print-none">
    <div class="row">
        <div class="col-lg-12 grid-margin stretch-card">
            <div class="card">
                <div class="card-body">
                    <h4 class="card-title">Approved ManPower Requests</h4>
                    <!-- <div class="input-group-append">
                        <button class="btn btn-sm btn-primary" type="button" (click)="downloadExcel()">Download</button>
                    </div> -->
                    <div class="table-responsive pt-3">
                        <nz-table #ManPowerTable [nzData]="approvedManPower" [nzPageSize]="50">
                            <thead>

                                <tr>
                                    <th>
                                        #
                                    </th>

                                    <th>
                                        Request Date
                                    </th>
                                    
                                    <th>
                                        Requester Name
                                    </th>

                                    <th>
                                        Requester Designation
                                    </th>

                                    <th>
                                        Required Role
                                    </th>

                                   <th>
                                        Requester Function
                                    </th>

                                    <th>
                                        Location
                                    </th>

                                  
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let data of ManPowerTable.data; let i = index ;" (click)="open(data)">

                                    <td>
                                        {{i+1}}
                                    </td>
                                    <td>
                                        {{ data.createdDate | date: 'dd MMMM yyy' }}
                                    </td>

                                  

                                    <td>
                                        {{data.requesterName}}
                                    </td>

                                    <td>
                                        {{data.requesterDesignation}}
                                    </td>

                                    <td>
                                        {{data.jobTitle}}
                                    </td>

                                    <td>
                                        {{data.requesterFunction}}
                                    </td>

                                    <td>
                                        {{data?.location}}
                                    </td>
                                  
                                </tr>
                            </tbody>
                        </nz-table>

                    </div>
                </div>
            </div>
        </div>


    </div>
</div>
